import { render, staticRenderFns } from "./TunnelsTable.vue?vue&type=template&id=47dab20f&scoped=true"
import script from "./TunnelsTable.vue?vue&type=script&lang=js"
export * from "./TunnelsTable.vue?vue&type=script&lang=js"
import style0 from "./TunnelsTable.vue?vue&type=style&index=0&id=47dab20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dab20f",
  null
  
)

export default component.exports